"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRepositionedRect = void 0;
var getRepositionedRect = function (popupRect, boundaryRect, boundaryInset) {
    var topBoundary = boundaryRect.top + boundaryInset;
    var leftBoundary = boundaryRect.left + boundaryInset;
    var rightBoundary = boundaryRect.right - boundaryInset;
    var bottomBoundary = boundaryRect.bottom - boundaryInset;
    var top = popupRect.top < topBoundary ? topBoundary : popupRect.top;
    top = top + popupRect.height > bottomBoundary ? bottomBoundary - popupRect.height : top;
    var left = popupRect.left < leftBoundary ? leftBoundary : popupRect.left;
    left = left + popupRect.width > rightBoundary ? rightBoundary - popupRect.width : left;
    return new DOMRect(left, top, popupRect.width, popupRect.height);
};
exports.getRepositionedRect = getRepositionedRect;
